import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
//Import formik validation
import { Spinner } from "reactstrap";

//Import Images
import house_icon from "../../assets/images/auth_home_icon.png";
import RestorePasswordSuccess from "../../assets/images/RestorePasswordSuccess.png";
import config from "../../config";

const ResetPasswordSuccess = () => {
    const [loading, setLoading] = React.useState(false);
    const navigate = useNavigate();

    document.title = `Success | ${config.get("COMPANY_NAME")}`;

    return (
        <div className="auth-main-wrapper">
            <div
                className="md:tw-bg-none tw-bg-center tw-bg-cover tw-w-full tw-h-full tw-flex tw-justify-between max-sm:tw-overflow-y-scroll"
                style={{ backgroundImage: `url(${house_icon})` }}
            >
                <div
                    style={{ backgroundImage: `url(${house_icon})` }}
                    className="max-sm:tw-hidden tw-relative tw-bg-center tw-bg-cover tw-w-full tw-m-2 "
                >
                    <div className="tw-absolute tw-inset-0 tw-bg-black tw-opacity-30"></div>

                    <div className="tw-absolute tw-top-[40px] tw-left-[30px] tw-flex tw-gap-2 tw-z-10">
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/5c704c298b9ced9c12fdf92061da095dec0b48ab751d0dab56ea704d9d9b3733?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                            alt="AiRE BROKERS logo"
                            className="logo tw-w-[35px] tw-h-[35px]"
                        />
                        <span className={`brandName tw-text-[16px] `}>{config.get("COMPANY_NAME")}</span>
                    </div>
                </div>

                <div
                    // style={{ background: "rgba(0, 0, 0, 0.68)" }}
                    className="tw-h-full  max-sm:tw-h-fit tw-w-full max-sm:tw-text-white max-sm:tw-bg-blur_background max-sm:tw-backdrop-blur-lg max-sm:tw-rounded-tl-[40px] max-sm:tw-rounded-tr-[40px]  md:tw-px-10 max-sm:tw-px-5  max-sm:tw-mt-52 tw-flex tw-overflow-y-auto tw-justify-center tw-z-10 "
                >
                    <div className="md:tw-max-w-[526px] 2xl:tw-max-w-[721px] tw-h-full tw-items-center  tw-flex tw-justify-center tw-pt-5  tw-w-full max-sm:tw-mt-10 max-sm:tw-mb-3">
                        <div className="tw-flex tw-flex-col tw-items-center tw-gap-2  2xl:tw-gap-5 ">
                            <div>
                                <img src={RestorePasswordSuccess} alt="" className="tw-h-[120px] tw-w-[120px]" />
                            </div>
                            <div className=" tw-flex tw-flex-col tw-gap-[10px]">
                                <h1 className="tw-text-[36px] tw-font-semibold tw-text-center 2xl:tw-text-[50px] max-sm:tw-text-[24px] ">Success </h1>
                                <p className="tw-text-[16px] tw-text-center 2xl:tw-text-[20px] md:tw-text-semi_dark_text max-sm:tw-font-thin">
                                    Your password has been reset successfully{" "}
                                </p>
                            </div>

                            <div className="tw-flex tw-flex-col">
                                <button
                                    onClick={() => navigate("/login")}
                                    className="tw-bg-primary tw-border-none tw-text-white tw-mt-5 tw-p-3 tw-px-10 tw-rounded-md 2xl:tw-text-[18px]"
                                    disabled={loading ? true : false}
                                >
                                    {loading ? <Spinner size="sm" color="light" /> : "Login Page"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordSuccess;
